
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageLayout from '@/components/PageLayout';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <PageLayout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-xl text-delphi-light/60 mb-4">Oops! Page not found</p>
          <a href="/" className="text-delphi-red hover:text-red-400 underline">
            Return to Home
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFound;
